import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "mb-1" }
const _hoisted_3 = { class: "mt-4 text-muted d-flex" }
const _hoisted_4 = { class: "flex-fill pr-2" }
const _hoisted_5 = {
  key: 0,
  class: "pl-2"
}

import {computed, ref} from "vue";
import ReactiveRequest from "~/core-ui/ts/request/ReactiveRequest";
import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";
import LcabApiResult from "~/cabinet/ts/api/LcabApiResult";
import {IForm} from "~/cabinet/vue/interface/form/elements/Interfaces";
import Dictionary from "~/ts/library/Dictionary";
import ReactiveRequestLoader from "~/cabinet/vue/interface/data/ReactiveRequestLoader.vue";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import MyForm from "~/cabinet/vue/interface/form/elements/MyForm.vue";
import CabinetAnalyticCountersSenderInstance from "~/cabinet/ts/service/CabinetAnalyticCountersSender";
import {isMobileWindowSize} from "~/core-ui/ts/CoreUiHelpersMixin";
import ObjectHelper from "~/ts/library/ObjectHelper";
import SocnetButtons from "~/cabinet/vue/auth/SocnetButtons.vue";
import {EventManagerInstance} from "~/cabinet/ts/Constant";
import {REFRESH_CAPTCHA_EVENT_NAME} from "~/cabinet/vue/interface/form/elements/CaptchaExposeInterface";
import {OAuthEventPayloadInterface} from "~/cabinet/vue/auth/Interface";

interface RegistrationFormDataInterface {
    form: IForm,
    codeword?: string,
    rules?: string,
    showCaptcha?: boolean,
}


const __default__ = {
    name: "RegFormDialog"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    initialEmail: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["done"], ["update:visible"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

const CAPTCHA_NAME = "captcha";
const PROMOCODE_NAME = "promocode";

let showCaptcha = ref(false);
let showPromocode = ref(false);

let visible = _useModel<boolean>(__props, "visible");

let rulesDisplayed = ref(false);
let regFormModel = ref<Dictionary<string>>({});


let regFormRequest = computed(() => {
    return (new ReactiveRequest<RegistrationFormDataInterface>(new LcabApiRequest({
        url: "/api/auth/getRegistrationForm"
    }))).setErrorCallback(() => {
        visible.value = false;
    }).setCallback(data => {
        if (data.codeword) {
            regFormModel.value.promocode = data.codeword;
            let item = data.form.sections[0].elements.find(item => item.name === PROMOCODE_NAME);
            if (item) {
                item.readonly = true;
                showPromocode.value = true;
            }
        }
        showCaptcha.value = !!data.showCaptcha;
        if (props.initialEmail && !regFormModel.value.email) {
            regFormModel.value.email = props.initialEmail;
        }
        CabinetAnalyticCountersSenderInstance.reachGoal("lcab_reg_form_display");
    });
});

let form = computed(() => {
    let result = regFormRequest.value.data?.form;
    if (result) {
        result = ObjectHelper.jsonClone(result);
        for (let section of result.sections) {
            section.elements = section.elements.filter(item => {
                if (item.name == CAPTCHA_NAME) {
                    return showCaptcha.value;
                } else if (item.name == PROMOCODE_NAME) {
                    return showPromocode.value;
                }
                return true;
            });
        }
    }
    return result;
});

let hasPromocodeInForm = computed(() => {
    return !!regFormRequest.value.data?.form?.sections.find(section => !!section.elements.find(element => element.name === PROMOCODE_NAME));
});

let formInputCount = computed(() => {
    let result = 0;
    if (form.value) {
        for (let section of form.value.sections) {
            result += section.elements.length;
        }
    }
    return result;
});

let isTopLabelForm = computed(() => {
    return formInputCount.value < 5 || isMobileWindowSize.value;
})

async function makeRegistration() {
    if (regFormModel.value.acceptRules || !regFormRequest.value.data.rules) {
        let result = await LcabApiRequest.fetch({
            url: "/api/auth/makeRegistration",
            p: {
                form: regFormModel.value
            }
        });
        if (!result.showMessageOnError()) {
            document.dispatchEvent(new CustomEvent('account-registered'));

            emits("done", {
                login: result.getData("login"),
                password: result.getData("password")
            });
            visible.value = false;
            result.showMessage();
            if (result.getData("reload")) {
                window.location.href = LcabApiRequest.getCabinetUrlPrefix();
            }
        } else {
            EventManagerInstance.emit(REFRESH_CAPTCHA_EVENT_NAME);
            if (result.getData("needCaptcha")) {
                showCaptcha.value = true;
            }
        }
    } else {
        LcabApiResult.showError("Требуется подтвердить согласие с правилами сервиса");
    }
}

async function onOAuth(p: OAuthEventPayloadInterface) {
    let result = await LcabApiRequest.save<{
        isDualAuthRequired?: boolean,
        isActivationRequired?: boolean,
        isIpDisallowed?: boolean,
        dualAuthEmail?: string
    }>({
        url: `/api/auth/${p.oAuthProviderId}/registrationByOAuth`,
        p: p.result
    });
    if (result.isSuccess) {
        window.location.href = "/";
    }
}



return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_unref(visible))
    ? (_openBlock(), _createBlock(MyDialog, {
        key: 0,
        dialog: {
            modal: false,
            class: _unref(isMobileWindowSize) ? `full-height-body` : undefined
        },
        width: _unref(isTopLabelForm) ? `400px` : `600px`,
        visible: _unref(visible),
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
        "button-text": "Зарегистрироваться",
        title: "Регистрация",
        "show-standart-buttons": false,
        fullscreen: _unref(isMobileWindowSize),
        "mobile-full-width-button": ""
      }, {
        default: _withCtx(() => [
          _createVNode(ReactiveRequestLoader, { request: _unref(regFormRequest) }, {
            default: _withCtx(() => [
              (_unref(regFormRequest).data)
                ? (_openBlock(), _createBlock(_component_el_form, {
                    key: 0,
                    model: _unref(regFormModel),
                    "label-position": _unref(isTopLabelForm) ? 'top' : 'left',
                    "label-width": "190px",
                    class: "reg-form"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(MyForm, {
                        modelValue: _unref(regFormModel),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(regFormModel) ? (regFormModel).value = $event : regFormModel = $event)),
                        form: _unref(form)
                      }, null, 8, ["modelValue", "form"]),
                      (_unref(regFormRequest).data.rules)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            class: "mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _unref(regFormModel).acceptRules,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(regFormModel).acceptRules) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _cache[7] || (_cache[7] = _createTextVNode(" Я согласен с ", -1)),
                                  _createElementVNode("a", {
                                    class: "link-dashed",
                                    tabindex: "",
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_isRef(rulesDisplayed) //@ts-ignore
 ? rulesDisplayed.value = true : rulesDisplayed = true), ["stop","prevent"]))
                                  }, "правилами сервиса"),
                                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-danger ml-1" }, "*", -1))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              (_unref(rulesDisplayed))
                                ? (_openBlock(), _createBlock(_component_el_dialog, {
                                    key: 0,
                                    modelValue: _unref(rulesDisplayed),
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(rulesDisplayed) ? (rulesDisplayed).value = $event : rulesDisplayed = $event)),
                                    class: "left",
                                    title: "Правила сервиса"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        innerHTML: _unref(regFormRequest).data.rules
                                      }, null, 8, _hoisted_1)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              class: "d-block w-100",
                              onClick: makeRegistration
                            }, {
                              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                _createTextVNode(" Зарегистрироваться ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createVNode(SocnetButtons, {
                            "registration-form": "",
                            onAuth: onOAuth
                          }),
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _cache[10] || (_cache[10] = _createTextVNode(" Уже есть аккаунт? ", -1)),
                              _createElementVNode("a", {
                                class: "cursor-pointer",
                                tabindex: "",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_isRef(visible) //@ts-ignore
 ? visible.value = false : visible = false))
                              }, " Войти ")
                            ]),
                            (!_unref(showPromocode) && _unref(hasPromocodeInForm))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  _createElementVNode("a", {
                                    class: "cursor-pointer",
                                    tabindex: "",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_isRef(showPromocode) //@ts-ignore
 ? showPromocode.value = true : showPromocode = true))
                                  }, " У меня есть промокод ")
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "label-position"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["request"])
        ]),
        _: 1
      }, 8, ["dialog", "width", "visible", "fullscreen"]))
    : _createCommentVNode("", true)
}
}

})